import { useState } from "react";
import { useTranslation } from "react-i18next";
import { forgotPassword } from "../Data/dataApi";
import { toast } from "react-toastify";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const { t } = useTranslation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setError("");

    // 🔒 validation front
    if (!email) {
      setError(t("forgotPassword.email-required"));
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError(t("forgotPassword.email-invalid"));
      return;
    }

    setLoading(true);

    try {
      await forgotPassword(email);

      toast.success(t("forgotPassword.confirmation"));

      setSent(true);
    } catch {
      toast.error(t("forgotPassword.sending-error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-container">
      <form className="forgot-form" onSubmit={handleSubmit}>
        <h2>{t("forgotPassword.title")}</h2>

        {!sent ? (
          <>
            <div className="form-group">
              <label>{t("forgotPassword.email")}</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t("forgotPassword.placeholder-email")}
              />
            </div>

            {error && <p className="error">{error}</p>}
            <br />
            <button
              className="forgot-button"
              type="submit"
              disabled={loading}
            >
              {loading ? "Envoi..." : t("forgotPassword.send")}
            </button>
          </>
        ) : (
          <p className="success-message">
            📩 Un email de réinitialisation a été envoyé si le compte existe.
          </p>
        )}

        <div className="forgot-link">
          <a href="/login">{t("forgotPassword.return")}</a>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;